<script>
export default {
    props: {
        partner: {
            type: Object,
            default: false
        }
    },
    computed: {
        updateTeamsSubscriptionUrl() {
            return `/api/admin/teams/update-teams-subscription`;
        },
        updateTeamsClickhintSubscriptionUrl() {
            return `/api/admin/teams/update-clickhint-subscriptions`;
        },
        updateTeamsCasesSubscriptionUrl() {
            return `/api/admin/teams/update-case-subscriptions`;
        },
        teamsUrl() {
            return this.partner
                ? `/api/partner/teams/${this.partner.id}`
                : "/api/admin/teams";
        },
        usersUrl() {
            return this.partner
                ? `/api/partner/users/${this.partner.id}`
                : "/api/admin/users";
        },
        createTeamsUrl() {
            return this.partner
                ? `/api/partner/${this.partner.id}/batch-create`
                : `/api/admin/teams/batch-create`;
        },
        membersUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/members`
                : `/api/admin/teams/${this.team.id}/members`;
        },
        metricsUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/metrics`
                : `/api/admin/teams/${this.team.id}/metrics`;
        },
        deactivateUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/deactivate`
                : `/api/admin/teams/${this.team.id}/deactivate`;
        },
        reactivateUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/reactivate`
                : `/api/admin/teams/${this.team.id}/reactivate`;
        },
        updateSubscriptionUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/update-subscription`
                : `/api/admin/teams/${this.team.id}/update-subscription`;
        },
        createSubscriptionUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/create-subscription`
                : `/api/admin/teams/${this.team.id}/create-subscription`;
        },
        updateTrialUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/update`
                : `/api/admin/teams/${this.team.id}/update`;
        },
        updateClickhintUrl() {
            return this.partner
                ? `/api/partner/teams/${
                      this.team.id
                  }/update-clickhint-subscription`
                : `/api/admin/teams/${
                      this.team.id
                  }/update-clickhint-subscription`;
        },
        createClickhintUrl() {
            return this.partner
                ? `/api/partner/teams/${
                      this.team.id
                  }/create-clickhint-subscription`
                : `/api/admin/teams/${
                      this.team.id
                  }/create-clickhint-subscription`;
        },
        createCaseSubscriptionUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/create-case-subscription`
                : `/api/admin/teams/${this.team.id}/create-case-subscription`;
        },
        updateCaseSubscriptionUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/update-case-subscription`
                : `/api/admin/teams/${this.team.id}/update-case-subscription`;
        },
        inviteUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/add-user`
                : `/api/admin/teams/${this.team.id}/add-user`;
        },
        behemothUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/scraper`
                : `/api/admin/teams/${this.team.id}/scraper`;
        },
        behemothMigrateUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/scraper/migrate`
                : `/api/admin/teams/${this.team.id}/scraper/migrate`;
        },
        behemothMigrateAllUrl() {
            return this.partner
                ? `/api/partner/teams/${this.team.id}/scraper/migrate-all`
                : `/api/admin/teams/${this.team.id}/scraper/migrate-all`;
        },
        manageSourcesUrl() {
            return process.env.NODE_ENV === 'development'
                ? `http://dev-webui.guestflip.io`
                : `https://pages.guestflip.io/behemoth`;
        }
    }
};
</script>
